// Настройки устройства (ux/11 §2.1): размер текста, меньше движения, экономия батареи — `localStorage` и атрибуты
// корня; громкость звуков — audio/sfx. Переносимые настройки (музыка, звуки, вибрация, рука, тема, реклама) — ещё и
// на сервере: Player.settings в /me и bootstrap, запись PATCH /me (Р-100); при входе значение сервера главнее.
import { storage } from './storage.js';

export type TextSize = 100 | 115 | 130;
export const TEXT_SIZES: readonly TextSize[] = [100, 115, 130];

export function textSize(): TextSize {
  const v = Number(storage.get('textSize'));
  return (TEXT_SIZES as readonly number[]).includes(v) ? (v as TextSize) : 100;
}
/** «Меньше движения»: по умолчанию — как в системе (prefers-reduced-motion). */
export function reduceMotion(): boolean {
  const v = storage.get('reduceMotion');
  if (v === 'on') return true;
  if (v === 'off') return false;
  return globalThis.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
}
export const batterySaver = (): boolean => storage.get('battery') === 'on';

/** Применить к документу: data-text (масштаб интерфейса), data-motion. Вызывается при старте и из настроек. */
export function applyPrefs(root: HTMLElement = document.documentElement): void {
  root.dataset.text = String(textSize());
  root.dataset.motion = reduceMotion() ? 'reduce' : 'full';
}

/** Настройки игрока с сервера (Player.settings, Р-100). */
export interface ServerSettings { music?: number; sfx?: number; vibration?: boolean; hand?: 'right' | 'left'; theme?: 'telegram' | 'light' | 'dark'; ads?: boolean; calmPace?: boolean }

/** Сервер → устройство: записать то, что пришло (нет поля — оставить как есть). true — сменилась тема. */
export function applyServerSettings(s: ServerSettings | undefined): boolean {
  if (!s) return false;
  const before = storage.get('theme');
  if (s.music !== undefined) storage.set('musicVolume', String(s.music));
  if (s.sfx !== undefined) storage.set('sfxVolume', String(s.sfx));
  if (s.vibration !== undefined) storage.set('vibration', s.vibration ? 'on' : 'off');
  if (s.hand) storage.set('hand', s.hand);
  if (s.theme) storage.set('theme', s.theme);
  if (s.ads !== undefined) storage.set('ads', s.ads ? 'on' : 'off');
  return storage.get('theme') !== before;
}

/** Устройство → сервер: текущие переносимые настройки для PATCH /me. */
export function deviceSettings(): Required<Omit<ServerSettings, 'calmPace'>> {
  const n = (k: string, d: number) => { const v = Number(storage.get(k) ?? d); return Number.isFinite(v) ? Math.max(0, Math.min(100, Math.round(v))) : d; };
  const theme = storage.get('theme');
  return {
    music: n('musicVolume', 60), sfx: n('sfxVolume', 80), vibration: storage.get('vibration') !== 'off',
    hand: storage.get('hand') === 'left' ? 'left' : 'right', theme: theme === 'light' || theme === 'dark' ? theme : 'telegram', ads: storage.get('ads') !== 'off',
  };
}
